import axios from "axios"

import { NODE_API_PREFIX, PPMC_API_PREFIX } from "@constants"
import { apiResponseLogger } from "@lib/utils"
import { getCookie, getDecodedAffiliateCookie } from "@commonUtils"
import config from "@config"

const COMMON_HEADERS = {
    "Content-Type": "application/json",
    "HKP-Platform": "Healthkartplus-0.0.1-desktopweb",
    Accept: "application/vnd.healthkartplus.v4+json",
    "X-Access-Key": "1mg_client_access_key",
    "X-1mgLabs-Platform": "dWeb",
}
const defaultCity = encodeURI(config.defaultCity.toLowerCase())
const API_TIMEOUT = 12500

const directAxiosInstance = (reqCookies, requestObj, customHeaders) => {
    const city = reqCookies?.city || defaultCity
    const locale = reqCookies?.locale || "en"
    const visitorID = reqCookies?.["VISITOR-ID"] || ""

    let xPlatform
    if (requestObj?.headers?.["x-platform"]) {
        xPlatform = requestObj.headers["x-platform"]
    } else {
        xPlatform = "desktop-0.0.1"
    }

    let headers = {
        ...COMMON_HEADERS,
        "X-City": city,
        "X-Visitor-Id": visitorID,
        "VISITOR-ID": visitorID,
        "x-platform": xPlatform,
        locale,
        ...customHeaders,
    }

    if (reqCookies?.["authToken"]) {
        headers["X-Authorization"] = reqCookies["authToken"]
    }

    if (requestObj?.headers?.authorization) {
        headers["X-Authorization"] = requestObj.headers.authorization
    }

    if (requestObj?.session?.AUTH_TOKEN && !headers["X-Authorization"]) {
        headers["X-Authorization"] = requestObj.session.AUTH_TOKEN
    }

    // Replace authorization token in case of super login
    if (requestObj?.session?.SUPER_LOGIN) {
        headers["X-Authorization"] = requestObj.session.SUPER_LOGIN
    }

    let baseURL = process.env.INTERNAL_NODE_API_URL + NODE_API_PREFIX
    if (typeof window === "undefined") {
        baseURL = process.env.EXTERNAL_DIRECT_API_URL
    }

    if (typeof window != "undefined" && getDecodedAffiliateCookie("affiliateDetails")) {
        const x_source = getDecodedAffiliateCookie("affiliateDetails")
        x_source && (headers["x-affiliate-source"] = x_source)
    } else if (reqCookies?.["affiliateDetails"]?._source) {
        headers["x-affiliate-source"] = reqCookies["affiliateDetails"]._source
    }

    if (typeof window !== "undefined") {
        headers = {
            ...headers,
            "X-Visitor-Id": getCookie("VISITOR-ID") || "",
            "X-City": getCookie("city") ?? defaultCity,
            "VISITOR-ID": getCookie("VISITOR-ID") || "",
        }
        if (getCookie("authToken")) {
            headers["X-Authorization"] = getCookie("authToken")
            headers["Authorization"] = getCookie("authToken")
        }
    }
    const proxyApi = axios.create({ baseURL, headers, timeout: API_TIMEOUT })

    proxyApi.interceptors.request.use((request) => {
        if (typeof window !== "undefined") {
            let newHeaders = {
                ...headers,
                ...request.headers,
                "X-Visitor-Id": getCookie("VISITOR-ID") || "",
                "X-City": getCookie("city"),
                "x-csrf-token": document.getElementsByName("_csrf")?.[0]?.value || "",
            }
            if (getCookie("authToken")) {
                newHeaders["X-Authorization"] = getCookie("authToken")
                newHeaders["Authorization"] = getCookie("authToken")
            }

            // Replace authorization token in case of super login
            if (getCookie("superLoginToken")) {
                newHeaders["X-Authorization"] = getCookie("superLoginToken")
                newHeaders["Authorization"] = getCookie("superLoginToken")
            }
            request.headers = newHeaders
        }
        return request
    })

    proxyApi.interceptors.response.use(
        (response) => {
            if (response.headers["set-cookie"]?.length > 0) {
                for (let index in response.headers["set-cookie"]) {
                    let cookie = response.headers["set-cookie"][index]
                    // const currentDomain = process.env.EXTERNAL_BASE_URL.substring(
                    //     8
                    // ); //without https:// part
                    // if (process.env.NODE_ENV !== "production") {
                    //     cookie = cookie.replace(
                    //         currentDomain,
                    //         "http://localhost:" + process.env.APPLICATION_PORT
                    //     );
                    // }
                    response.cookie = cookie
                }
            }
            if (process.env.DEBUG_MODE === "true") {
                apiResponseLogger(response)
            }
            return Promise.resolve(response.data)
        },
        (err) => {
            // if (err.response.config.url.indexOf("/api/v4/otc_skus/") !== -1) {
            //     console.log("current page is otc page");
            //     // it is otc page, check if id was of drug
            //     if (err.response.status == 404) {
            //         console.log("error status is 404");
            //         const otcError = err.response;
            //         if (otcError.data) {
            //             console.log("error data", otcError);
            //             otcError.data.meta
            //                 ? err.redirect(302, otcError.data.meta.slug)
            //                 : null;
            //         }
            //     }
            // }
            //transformed to new log format
            console.dir({
                service_name: "pwa-dweb-node-server",
                loglevel: "info",
                version: "v2",
                message: " ======== Proxy Api Error DirectAxios ========",
            })
            console.dir({
                service_name: "pwa-dweb-node-server",
                loglevel: "error",
                version: "v2",
                message: "Response error:\n",
                traceback: err,
            })
            let error = err?.response?.data
            if (err?.response?.status === 401 || err?.response?.status === 403) {
                if (typeof window !== "undefined") {
                    const redirectUrl = window.location.pathname
                    window.location.href = `/unauthorizeduser/?redirect=${redirectUrl}`
                }
            }
            if (!error) {
                error = {
                    status: 500,
                    message: "Something went wrong. Please try again later.",
                }
            }
            // if (error.status === 500 || error.status === 404) {
            //     if (typeof window !== "undefined") {
            //         window.location.href = "404";
            //     }
            // }
            return Promise.reject(error)
        }
    )
    return proxyApi
}

const ppmcAxiosInstance = (reqCookies, requestObj) => {
    const city = reqCookies?.city || defaultCity
    const locale = reqCookies?.locale || "en"
    const visitorID = reqCookies?.["VISITOR-ID"] || ""

    let xPlatform
    if (getCookie("x-platform")) {
        xPlatform = getCookie("x-platform")
    } else if (requestObj?.headers?.["x-platform"]) {
        xPlatform = requestObj.headers["x-platform"]
    } else {
        xPlatform = "desktop-0.0.1"
    }

    let headers = {
        ...COMMON_HEADERS,
        "X-City": city,
        "X-Visitor-Id": visitorID,
        "VISITOR-ID": visitorID,
        "x-platform": xPlatform,
        locale,
    }

    let baseURL = process.env.INTERNAL_NODE_API_URL + NODE_API_PREFIX + PPMC_API_PREFIX
    if (typeof window === "undefined") {
        baseURL = process.env.EXTERNAL_PPMC_DIRECT_API_URL
    }
    if (typeof window !== "undefined") {
        headers = {
            ...headers,
            "X-Visitor-Id": getCookie("VISITOR-ID") || "",
            "X-City": getCookie("city") ?? defaultCity,
            "VISITOR-ID": getCookie("VISITOR-ID") || "",
        }
    }
    if (typeof window === "undefined" && reqCookies) {
        if (reqCookies["selfServeToken"]) {
            headers["x-self-serve-token"] = reqCookies["selfServeToken"]
        }
        if (reqCookies["selfServeUUID"]) {
            headers["uuid"] = reqCookies["selfServeUUID"]
        }
        if (reqCookies["selfServeReschedule"]) {
            headers["reschedule_reason_id"] = reqCookies["selfServeReschedule"]
        }
    }

    const proxyApi = axios.create({ baseURL, headers, timeout: API_TIMEOUT })

    proxyApi.interceptors.request.use((request) => {
        if (typeof window !== "undefined") {
            let newHeaders = {
                ...headers,
                ...request.headers,
                "X-Visitor-Id": getCookie("VISITOR-ID") || "",
                "X-City": getCookie("city"),
                "x-csrf-token": document.getElementsByName("_csrf")?.[0]?.value || "",
            }
            if (getCookie("selfServeToken")) {
                newHeaders["x-self-serve-token"] = getCookie("selfServeToken")
            }
            if (getCookie("selfServeUUID")) {
                newHeaders["uuid"] = getCookie("selfServeUUID")
            }
            if (getCookie("selfServeReschedule")) {
                newHeaders["reschedule_reason_id"] = getCookie("selfServeReschedule")
            }

            request.headers = newHeaders
        }
        return request
    })

    proxyApi.interceptors.response.use(
        (response) => {
            if (response.headers["set-cookie"] && response.headers["set-cookie"].length > 0) {
                for (const index in response.headers["set-cookie"]) {
                    response.cookie = response.headers["set-cookie"][index]
                }
            }
            if (process.env.DEBUG_MODE === "true") {
                apiResponseLogger(response)
            }
            return Promise.resolve(response.data)
        },
        (err) => {
            //transformed to new log format
            console.dir({
                service_name: "pwa-dweb-node-server",
                loglevel: "info",
                version: "v2",
                message: " ======== Proxy Api Error PPMC Instance ========",
            })
            console.dir({
                service_name: "pwa-dweb-node-server",
                loglevel: "error",
                version: "v2",
                message: "Response error:\n",
                traceback: err,
            })
            let error = err?.response?.data
            if (!error) {
                error = {
                    status: 500,
                    message: "Something went wrong. Please try again later.",
                }
            }
            return Promise.reject(error)
        }
    )
    return proxyApi
}

export { directAxiosInstance, ppmcAxiosInstance }
